module.exports = __webpack_public_path__ + "static/media/cloud2.5bfd6064.svg";